export type RouteKey = keyof typeof Route

const Route = {
  main: '/',
  post: '/post',
  // about: '/about',
}

export default Route
